import { render, staticRenderFns } from "./HHTextTruncate.vue?vue&type=template&id=39f865ef&"
import script from "./HHTextTruncate.vue?vue&type=script&lang=js&"
export * from "./HHTextTruncate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports